// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EntlibResponseMedicareReportResponseModel } from './entlibResponseMedicareReportResponseModel.js';
import type { IEntlibFailureResponse } from './iEntlibFailureResponse.js';
import type { MedicareReportResponseModel } from './medicareReportResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PolicyReporterV1DeliverableReportsGetMedicareReportResponse {
    'data': MedicareReportResponseModel | null;
    'success': boolean;
    'messages': Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PolicyReporterV1DeliverableReportsGetMedicareReportResponse>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "MedicareReportResponseModel"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return PolicyReporterV1DeliverableReportsGetMedicareReportResponse.attributeTypeMap;
    }
}
